import {JsonValue} from 'type-fest';

export function isJsonizable(o?: any): o is { toJSON?: () => JsonValue; toJson?: () => JsonValue; toMutableJSON?: () => JsonValue } {
    return typeof o?.toJSON === 'function'
        || typeof o?.toJson === 'function'
        || typeof o?.toMutableJSON === 'function';
}
